import styled from 'styled-components'
import breakpoint from '../../../commons/breakpoints'

// eslint-disable-next-line import/prefer-default-export
export const JobDetailWrapper = styled.div`
  margin: 20px;
  font-size: 125%;
  line-height: 1.9;
  h2 {
    font-size: 32px;
    margin-bottom: 0;
    font-weight: bold;
    display: flex;
    align-items: center;
    text-transform: capitalize;

    span {
      margin-left: 15px;
      font-size: 11px;
      font-weight: 600;
    }
  }
  .location {
    opacity: 0.55;
    margin-bottom: 50px;
    font-size: 18px;
  }
  .description {
    max-width: 980px;
    p {
    }
    h3 {
      font-weight: 700;
      font-size: 20px;
    }
  }

  .jobDetailHeaderWrapper {
    display: flex;
    justify-content: space-between;
  }
  /* @media only screen and ${breakpoint.device.s}{
    .jobDetailHeaderWrapper {
     flex-direction: column;
    }
    .location {
      margin-bottom: 5px;
    }
    h2 {
      font-size: 22px;
      display: flex;
      flex-direction: column;
      align-items:flex-start;
      
      span {
        margin: 0;
      }
    }

    .ant-btn {
      width: 100%
    }
    
  } */
`

// eslint-disable-next-line import/prefer-default-export
export const OfferInformationWrapper = styled.div`
  .info-wrapper {
    display: flex;
    flex-wrap: wrap;
  }

  .filters {
    display: flex;
    flex-wrap: wrap;
    font-size: 14px;
    opacity: 0.55;
    gap: 20px;
    row-gap: inherit;
  }
  .inter-filters {
    display: flex;
    align-items: center;
    gap: 4px;
  }
`
